export enum CommandOrchestrationFinishState {
    SUCCESS, ERROR
}
